import React, {useContext} from 'react';
import {ProductContext} from "../../../../../pages/ProductStencil";
import {useI18N} from "../../../../../my-puratos/hoc/withI18N";

export const ContactUs = () => {
    const {contactUsFindStockist} = useContext(ProductContext);
    const translate = useI18N();

    if(!contactUsFindStockist){
        return null;
    }

    return (
        <div className={`contact-us`}>
            <div dangerouslySetInnerHTML={{__html: (contactUsFindStockist.text)}}></div>
            <a className="btn btn-secondary" href={contactUsFindStockist.contactUsLink.url}>{translate(contactUsFindStockist.contactUsLink.label)}</a>
        </div>
    )
}
